import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { InlineStack, Text, Icon } from "@shopify/polaris";
import {
  TextAlignLeftIcon,
  ImageIcon,
  TextWithImageIcon,
  ListBulletedIcon,
  PlayCircleIcon,
  CollectionFilledIcon,
  CodeIcon,
  CategoriesIcon,
  ClockIcon,
  LayoutPopupIcon,
  ChannelsIcon,
  MenuIcon,
  LayoutSectionIcon,
  TextIcon,
} from "@shopify/polaris-icons";
import "react-sliding-pane/dist/react-sliding-pane.css";

export const SectionCollapseOutside = forwardRef((props, ref) => {
  const switchTitle = (param) => {
    switch (param) {
      case "rich_text":
        return "Rich Text";
      case "banner":
        return "Banner";
      case "image":
        return "Image with text";
      case "list":
        return "List";
      case "video":
        return "Video";
      case "shopify_collection":
        return "Shopify Collection";
      case "code":
        return "code";
      case "shopify_products_list":
        return "List of Shopify Products";
      case "countdown":
        return "Countdown";
      case "navigation":
        return "Navigation";
      case "popup":
        return "Popup";
      case "object":
        return "Object";
      case "iframe":
        return "Iframe";
      case "custom_block":
        return "Custom Block";
      default:
        return null;
    }
  };
  const switchIcon = (param) => {
    switch (param) {
      case "rich_text":
        return TextAlignLeftIcon;
      case "banner":
        return ImageIcon;
      case "image":
        return TextWithImageIcon;
      case "list":
        return ListBulletedIcon;
      case "video":
        return PlayCircleIcon;
      case "shopify_collection":
        return CollectionFilledIcon;
      case "code":
        return CodeIcon;
      case "shopify_products_list":
        return CategoriesIcon;
      case "countdown":
        return ClockIcon;
      case "popup":
        return LayoutPopupIcon;
      case "navigation":
        return MenuIcon;
      case "object":
        return LayoutSectionIcon;
      case "iframe":
        return CodeIcon;
      case "custom_block":
        return TextIcon;
      default:
        return "";
    }
  };

  return (
    <div className="accordion-item" id={props.id}>
      <h2
        className="accordion-header"
        id="heading-m3q819"
        {...props.dragHandleProps}
      >
        <div
          onClick={() => {
            props.updateOpenArrayStateClose(props.sectionId);
          }}
          role="button"
          tabIndex="0"
          className={`accordion-button collapsed`}
          type="button"
          aria-expanded="false"
          aria-controls="collapse-m3q819"
          aria-label="aa"
        >
          {
            <InlineStack gap="200" align="center" blockAlign="center">
              {/* Replace Stack.Item with just a child element */}
              <div>
                <div
                  style={{
                    minWidth: "10rem",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div style={{ width: "2rem", opacity: "0.5" }}>
                    <Icon source={switchIcon(props.type)} color="subdued" />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Text variant="bodyMd" as="p" fontWeight="regular">
                      {`${
                        JSON.parse(props?.object) &&
                        JSON.parse(props?.object)?.title["en"]
                          ? `${JSON.parse(props?.object)
                              .title["en"].replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, "")
                              .replaceAll(";;;", " ")}`
                          : switchTitle(props.type)
                      }`}
                    </Text>
                  </div>
                </div>
              </div>
            </InlineStack>
          }
        </div>
      </h2>
    </div>
  );
});
